import React, { useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route, useLocation } from 'react-router-dom';
import { HelmetProvider } from 'react-helmet-async';

// Styles
import './styles/variables.css';

// Data
import { companyInfo } from './data';
import './styles/components-index.css';
import './styles/pages-index.css';

// Components
import Navbar from './components/Navbar';
import Footer from './components/Footer';
import WhatsAppWidget from './components/WhatsAppWidget';

// Pages
import Home from './pages/Home';
import About from './pages/About';
import Services from './pages/Services';
import Contact from './pages/Contact';

// Scroll to top on route change
const ScrollToTop = () => {
    const { pathname } = useLocation();

    useEffect(() => {
        window.scrollTo(0, 0);
    }, [pathname]);

    return null;
};

function App() {
    // Swap default favicon with branded logo
    useEffect(() => {
        const favicon =
            document.querySelector("link[rel*='icon']") || document.createElement('link');
        favicon.rel = 'icon';
        favicon.type = 'image/png';
        favicon.href = '/logo-phoenix-ai.png';
        document.head.appendChild(favicon);
    }, []);

    return (
        <HelmetProvider>
            <Router>
                <ScrollToTop />
                <div className="app">
                    <Navbar />
                    <Routes>
                        <Route path="/" element={<Home />} />
                        <Route path="/about" element={<About />} />
                        <Route path="/services" element={<Services />} />
                        <Route path="/contact" element={<Contact />} />
                    </Routes>
                    <Footer />
                    <WhatsAppWidget phoneNumber={companyInfo.whatsapp.number} message={companyInfo.whatsapp.message} />
                </div>
            </Router>
        </HelmetProvider>
    );
}

export default App;
